import { render, staticRenderFns } from "./TagModal.vue?vue&type=template&id=ac4896f6&scoped=true&"
import script from "./TagModal.vue?vue&type=script&lang=js&"
export * from "./TagModal.vue?vue&type=script&lang=js&"
import style0 from "./TagModal.vue?vue&type=style&index=0&id=ac4896f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4896f6",
  null
  
)

export default component.exports